import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { currentDossier } = useSelector((s) => s.dossiers);

 /*  if (!currentDossier || currentDossier.etat_confirmation !== 1) {
    return <Navigate to="/" replace />;
  } */

  return children;
};

export default ProtectedRoute;